<template>
  <section style="position:relative">
    <v-card>
      <v-card-title>
        <span class="text-h4">
          Bot
          <span class="pl-3 subtitle-1">Setup</span>
        </span>
      </v-card-title>
      <v-card-text>
        <div>
          <p class="title font-weight-light">Token</p>
          <p class="subtitle-1">{{bot.token | str_limit(8, 8)}}</p>
        </div>
        <v-banner single-line>
          <v-icon slot="icon" :color="statusColour" size="36">mdi-check-network-outline</v-icon>
          
          <span class="title">
            {{bot.first_name}} {{bot.last_name}}
            <span
              class="pl-2 subtitle-1 font-weight-light"
            >@{{bot.username}}</span>
          </span>
          <template v-slot:actions>
            <v-switch
              v-model="bot.active"
              @change="saveBot()"
              inset
              class="px-4 py-2"
              label="Active"
              :persistent-hint="true"
            ></v-switch>
            <v-btn color="primary" outlined @click="reboot()">Restart</v-btn>
          </template>
        </v-banner>
        <v-banner v-if="bot.dyno_state">
          <span class="title">
            <span class="subtitle-1 font-weight-light">Status:</span>
            <span class="pl-2">{{bot.dyno_state[0].toUpperCase() + bot.dyno_state.slice(1)}}</span>
            <span class="subtitle-2 font-weight-light" v-if="bot.dyno_state !== 'up'">
              <br />Launching the bot can take a few minutes...time to make yourself a nice cup of something warm!
            </span>
          </span>
        </v-banner>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import { apiClient } from "@/api";
import { models } from "feathers-vuex";

export default {
  data: () => ({}),
  computed: {
    statusColour() {
      let colours = {
        starting: "amber lighten-1",
        crashed: "red darken-1",
        up: "green darken-1"
      };

      return colours[this.bot.dyno_state] || "danger";
    }
  },
  methods: {
    async saveBot() {
      const { Bot } = models.api;
      let bot = new Bot(this.bot);
      bot.save();
    },
    async reboot() {
      // reboot the dyno
      // must use feathersClient directly because Vuex doesn't support params with remove
      try {
        await apiClient.service("heroku").remove(this.bot.app_id);
      } catch (error) {
        console.log('Error rebooting bot: ', error)
      }
    }
  },

  props: ["bot"]
};
</script>